import React, { FC } from 'react';
import dayjs from 'dayjs';
import { BaseTable } from '@sede-enterprise/shell-ds-react-framework';
import { COMMON_MESSAGES } from 'src/constants/Common';
import { Modal } from './style';
import Button from 'src/UI/Button';
import { INGParametersModal } from 'src/types/EUMarkets.type';

const Parameters: FC<INGParametersModal> = ({
  open,
  onClose,
  params,
  paramType,
}) => {
  const renderDate = ({ getValue }) => {
    const dateValue = getValue();
    return dateValue
      ? dayjs(dateValue).format(COMMON_MESSAGES.DATE_DD_MMM_YYYY)
      : 'No Expiry';
  };

  const renderValueByType = (item) => {
    if (item.valueBoolean !== null) {
      return item.valueBoolean.toString();
    }
    if (item.valueDouble !== null) {
      return item.valueDouble.toString();
    }
    if (item.valueLong !== null) {
      return item.valueLong.toString();
    }
    if (item.valueString !== null) {
      return item.valueString;
    }
    return '';
  };
  const columns = [
    {
      accessorKey: 'parameterName',
      header: 'Parameter Name',
    },
    {
      accessorKey: 'value',
      header: 'Parameter Value',
      cell: ({ row }) => renderValueByType(row.original),
    },
    {
      accessorKey: 'validFrom',
      header: 'Valid From',
      cell: renderDate,
    },
    {
      accessorKey: 'validTo',
      header: 'Valid To',
      cell: renderDate,
    },
  ];

  return (
    <Modal
      open={open}
      onClose={onClose}
      maskClosable={false}
      isDraggable
      width={660}
      footer={
        <div className='button-style'>
          <Button variant='outlined' onClick={onClose} data-testid='close'>
            Close
          </Button>
        </div>
      }
      title={`${paramType} Parameters`}
    >
      <div className='group-details'>
        <span className='param-title'>{paramType} Name :</span> {params?.name}
      </div>
      {/* Render parameters table here */}
      <BaseTable columns={columns} data={params?.parameters ?? []} />
    </Modal>
  );
};

export default Parameters;
